import logger from "@/console";

const englishLetterRegex = /^[a-zA-Z0-9\-\/\s_]*$/;

class Ga4Core {
  constructor() {
    this.hasLoaded = false;
    this.isInitialized = false;
  }

  gtag = (...args) => {
    if (typeof window !== "undefined") {
      if (typeof window.gtag === "undefined") {
        window.dataLayer = window.dataLayer || [];
        window.gtag = function gtag() {
          window.dataLayer.push(arguments);
        };
      }

      window.gtag(...args);
    }
  };

  pushEvent = (event) => {
    if (typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(event);
    }
  };

  /**
   *
   * @param {string} trackingID
   * @param {Object} initialData
   * @param {string} gtagUrl
   */
  load = (
    trackingID,
    initialData,
    // gtagUrl = "https://www.googletagmanager.com/gtag/js"
  ) => {
    if (typeof window === "undefined" || typeof document === "undefined") {
      return;
    }

    if (!this.hasLoaded) {
      // e-cens recommendations is to populate the initial data in the dataLayer before loading gtm script
      window.dataLayer = window.dataLayer || [];
      if (initialData) {
        window.dataLayer.push(initialData);
      }

      window.gtag = function gtag() {
        window.dataLayer.push(arguments);
      };

      this.hasLoaded = true;
    }
  };

  /**
   *
   * @param {string} trackingID
   * @param {Object} initialData
   */
  initialize = (trackingID, initialData) => {
    if (!trackingID) {
      throw new Error("GA Tracking ID is required");
    }

    this.load(trackingID, initialData);

    this.isInitialized = true;
  };

  formatPrimitiveProperty = (value) => {
    if (typeof value === "number") {
      return value;
    }

    if (typeof value === "string" && englishLetterRegex.test(value)) {
      return value.toLowerCase().replace(/\s+/g, "_");
    }

    return typeof value.toString === "function"
      ? value.toString().toLowerCase()
      : value;
  };

  /**
   * Sanitize the event object according to e-cens recommendations by:
   * 1. Converting all values to lowercase
   * 2. Removing any null or undefined values
   * 3. Logging a warning if any value contains non-English letters
   * @param {Object} obj
   */
  sanitizeEventObject = (obj) => {
    for (let key in obj) {
      if (
        obj[key] === null ||
        obj[key] === undefined ||
        typeof obj[key] === "undefined"
      ) {
        delete obj[key];
      } else if (Array.isArray(obj[key])) {
        obj[key] = obj[key].map((item) =>
          typeof item === "object"
            ? this.sanitizeEventObject(item)
            : this.formatPrimitiveProperty(item),
        );
      } else if (typeof obj[key] === "object") {
        obj[key] = this.sanitizeEventObject(obj[key]);
      } else {
        obj[key] =
          key === "item_id"
            ? obj[key].toString().toLowerCase()
            : this.formatPrimitiveProperty(obj[key]);

        if (!englishLetterRegex.test(obj[key])) {
          logger.warn(`Property ${key} contains non-English letters.`);
        }
      }
    }

    return obj;
  };

  /**
   *
   * @param {string} eventName
   * @param {Object} eventParams
   */
  trackUserInteraction = (eventName, eventParams = {}) => {
    const eventObject = {
      event: "eventTracker",
      custom_event_name: eventName,
      ...eventParams,
    };
    this.pushEvent(this.sanitizeEventObject(eventObject));
  };

  /**
   *
   * @param {string} eventName
   * @param {Object} eventParams
   * @param {string} journey_details
   */
  trackEcommerceEvent = (eventName, eventParams, journey_details) => {
    const eventObject = {
      event: "eventTracker",
      custom_event_name: eventName,
      ...(journey_details && { journey_details }),
      ecommerce: this.sanitizeEventObject(eventParams),
    };

    this.pushEvent(eventObject);
  };
}

const ga4 = new Ga4Core();
export default ga4;
